import { SELECT_BEST_AGENT_POINTS, SELECT_BEST_AGENT_TITLE } from './constants';
import { SelectBestAgent } from '../../components';
import { useState } from 'react';
import { QualityCriteriaModal } from '../../components/QualityCriteriaModal';
import { useApplicationContext } from '../../../common/utils/applicationContext';
import { clickBuyerBestAgent } from '../../utils/tracking';

export const SelectBestAgentContainer = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { custom } = useApplicationContext();

  const handleOpen = () => {
    setIsOpen(true);
    clickBuyerBestAgent(custom);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <SelectBestAgent
      title={SELECT_BEST_AGENT_TITLE}
      benefitsList={SELECT_BEST_AGENT_POINTS}
      modal={<QualityCriteriaModal handleClose={handleClose} isOpen={isOpen} />}
      handleOpen={handleOpen}
    />
  );
};
